import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h1>Cookie Policy – Samriddhi India</h1>

                <p>At Samriddhi India, we are committed to giving you the best possible online shopping experience for our clothing, kurtas, ethnic wear, trendy workwear, and women’s fashion. To make your visits more personalized and seamless, we use cookies and similar technologies on our website.</p>

                <p>By using our website, you agree to this Cookie Policy along with our Privacy Policy.</p>

                <h2>What Are Cookies?</h2>
                <p>Cookies are small text files stored on your device when you visit our website. They help us:</p>
                <ul>
                    <li>Remember your preferences like size, color, and product choices.</li>
                    <li>Provide a smooth browsing and shopping experience.</li>
                    <li>Improve website performance and speed up checkout.</li>
                    <li>Show you relevant fashion collections, kurtas, and trendy outfits based on your interests.</li>
                </ul>

                <p>There are two types of cookies we use:</p>
                <ul>
                    <li><strong>Session Cookies:</strong> Temporary cookies that expire when you close your browser.</li>
                    <li><strong>Persistent Cookies:</strong> Remain on your device until deleted or expired, allowing us to remember your preferences for your next visit.</li>
                </ul>

                <h2>Why We Use Cookies</h2>
                <p>Cookies help us enhance your fashion shopping journey by:</p>
                <ul>
                    <li>Saving your login details for faster sign-ins.</li>
                    <li>Showing you curated clothing collections and recommendations.</li>
                    <li>Analyzing how you browse our ethnic wear, kurtas, and trendy clothing to improve our website design.</li>
                    <li>Offering personalized promotions, discounts, and notifications about new arrivals.</li>
                </ul>

                <h2>Advertising & Analytics Cookies</h2>
                <p>We use cookies, pixels, and tags for advertising and analytics purposes. These allow us to:</p>
                <ul>
                    <li>Display Samriddhi India ads for kurtas, ethnic wear, and fashion collections on third-party websites.</li>
                    <li>Measure ad performance (e.g., clicks, purchases after ad views).</li>
                    <li>Avoid showing you the same ad repeatedly.</li>
                    <li>Partner with trusted platforms like Google Display Network and Meta (Facebook/Instagram) to bring you relevant shopping offers.</li>
                </ul>
                <p>This helps us improve your experience, show you fashion that matches your taste, and make your visits more enjoyable.</p>

                <h2>Managing Cookies</h2>
                <p>Most browsers allow you to control cookies — you can accept, reject, or delete them. If you disable cookies:</p>
                <ul>
                    <li>Some features like quick login, saved wishlist, and personalized product recommendations may not work.</li>
                    <li>You may need to re-enter your details every time you shop for clothing on our website.</li>
                </ul>
                <p>To manage your cookie settings, adjust your browser preferences.</p>

                <h2>Opting Out of Marketing Cookies</h2>
                <p>You may opt out of marketing and promotional communications at any time by clicking “Unsubscribe” in our emails or adjusting preferences in your Samriddhi India account settings.</p>

                <h2>Your Consent</h2>
                <p>By continuing to use Samriddhi India’s website and browsing our fashion collections, kurtas, and ethnic wear, you consent to the use of cookies as outlined in this Cookie Policy.</p>
            </MainBox>
            <Footer />
        </>
    );
};

export default CookiePolicy;
